import logoImg from "../../assets/logo/logo_jp.png";
import userIcon from "../../assets/icons/user.svg";
import exitIcon from "../../assets/icons/exit.svg";
import { useAuth } from "../../context/AuthContext";
import { formatCPFCNPJ } from '../../utils/formatCPFCNPJ'
import AcionaLogo from '../../assets/logo/header_logo2.svg'
import { useEffect, useState } from "react";

export function Header() {
  const { isAuthenticated, onLogout, cookies, decodedToken } = useAuth();
  const [user, setUser] = useState<any>()

  function decoded() {
    if (cookies?.token) {
      const userDecoded = decodedToken()
      setUser(userDecoded)
    }
  }
  useEffect(() => {
    decoded()
  }, [cookies?.token])

  return (
    <>
      <section>
        <div className={`flex h-14 ${isAuthenticated ? 'w-[97%] fixed left-[3.39rem] ' : 'w-full'} items-center justify-between bg-white  pl-10 shadow-md `}>
          <div>
            <img src={isAuthenticated ? AcionaLogo : logoImg} alt="" className={`w-[200px] ${isAuthenticated && '-ml-8'}`} />
          </div>

          {isAuthenticated && (
            <div className="flex h-full items-center gap-5  rounded-l-[3rem] bg-primary px-5 py-2">
              <img src={userIcon} alt="" />
              <div className="text-gray-50">
                <p>{user?.nome || ''}</p>
                <p>{user?.cpf_cnpj ? formatCPFCNPJ(user?.cpf_cnpj) : ''}</p>
              </div>
              <button onClick={() => onLogout()}>
                <img src={exitIcon} alt="" />
              </button>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
